import React, {  Component } from 'react';

const ImportFileExampleImage = ({ onClose }) => {
	return (
		<React.Fragment>
			<div className='importFileExampleBackdrop' onClick={onClose} />
			<img className='importFileExampleImage' src="../images/brochureSample.png" alt="" />
		</React.Fragment>
	);
};

export default class BrochureImportFileConfirmOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            showExampleImage: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('BrochureImportFileConfirmOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    handleExampleImage = event => {
        event.preventDefault();
        this.setState({showExampleImage: true});
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <a href='' className='pull-right bold red' onClick={this.handleExampleImage}>SEE EXAMPLE</a>
                    <h2 className="title">Import File</h2>
					<p>Only Excel or CSV files can be imported. Only one column of data is required and no headers should be used. The column should list complete model numbers and only valid model numbers wll be imported</p>
					<p>Do you want to continue?</p>
					<div className="noButtonContainer">
						<a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>No</a>
					</div>
					<div className="yesButtonContainer">
						<a className="yesButton blueButton" onClick={this.props.handleImportAction}>Yes</a>
					</div>
            	</div>
                {this.state.showExampleImage && <ImportFileExampleImage onClose={() => this.setState({showExampleImage: false})}/>}
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/brochureImportFileConfirmOverlayDialog.js